import { Component, Input } from '@angular/core';

@Component({
  selector: 'loading-component',
  standalone: true,
  templateUrl: './loading.component.html',
  styleUrls: [],
})
export class LoadingComponent {
  @Input() customClass: string = '';
}
